// This needs to partially match the entries in the backend's ExportTypeEnum
export enum ReportType {
  AdequacyServicingProvider = "adequacyServicingProvider",
  // AllSpecialties
  AdequacyAggregate = "adequacyAggregate",
  ZipSummary = "zipSummary",
  AdequacyNextClosestProvider = "adequacyNextClosestProvider",
  AdequacySpecialtySummary = "adequacySpecialtySummary",
  StateSummary = "stateSummary",
  CountySummary = "countySummary",
  SpecialtySummaryByCounty = "specialtySummaryByCounty",

  StateSummaryComparison = "stateSummaryComparison",
  CountySummaryComparison = "countySummaryComparison",
  SpecialtySummaryByCountyComparison = "specialtySummaryByCountyComparison",
  ZipSummaryComparison = "zipSummaryComparison",
  AdequacySpecialtySummaryComparison = "adequacySpecialtySummaryComparison",
}